import React, { Fragment, useEffect, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks'
import { findCompanyById } from '../../../../util/arraySearch'
import { UniqueKeyGenerator } from '../../../../util/uniqueKeyGenerator'

export const SlackIcon = (props: {
  slackUserId: string | undefined;
  companyId: number | undefined;
}): JSX.Element => {
  const companies = useAppSelector((state) => state.companies)

  const [companyUrl, setCompanyUrl] = useState<string>('')

  useEffect(() => {
    if (companies.length === 0) {
      return
    }
    if (!props.slackUserId || !props.companyId || props.companyId === 0) {
      return
    }
    const company = findCompanyById(props.companyId, companies)
    let curl = company?.slack_workspace_url

    if (!curl) {
      return
    }

    const lastChar = curl.substring(-1) // Selects the last character
    if (lastChar !== '/') {
      // If the last character is not a slash
      curl = curl + '/' // Append a slash to it.
    }

    setCompanyUrl(curl)
    //https://slack.com/intl/en-ch/help/articles/360003827751-Create-a-link-to-a-members-profile-

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies])

  return (
    <Fragment>
      {companyUrl && props.slackUserId ? (
        <a
          key={UniqueKeyGenerator('slack')}
          target={'_blank'}
          href={`${companyUrl}team/${props.slackUserId}`}
          rel="noreferrer"
        >
          <i className={'fab fa-slack business-card-social'} />
        </a>
      ) : (
        ''
      )}
    </Fragment>
  )
}